import Affirmation from "./affirmation/affirmation";
import AffirmationSuggestion from "./affirmationSuggestion/affirmationSuggestion";
import EnergyStones from "./energyStones/energyStones";
import Horoscope from "./horoscope/horoscope";
import Meditation from "./meditation/meditation";
import MemoryBook from "./memoryBook/memoryBook";
import MemoryTree from "./memoryTree/memoryTree";
import NatalChart from "./birthChart/natalChart";
import NewAccount from "./newAccount";
import Numerology from "./numerology/numerology";
import Synastry from "./synastry/synastry";
import TimeCapsule from "./timeCapsule/timeCapsule";
import VisionBoard from "./visionBoard/visionBoard";
import NewYearWishes from "./newYearWishes/newYearWishes";
import GroundingTechnique from "./groundingTechnique/groundingTechnique";
import BreathingTechnique from "./breathingTechnique/breathingTechnique";
import BodyScan from "./bodyScan/bodyScan";
import AnchoringTechnique from "./anchoringTechnique/anchoringTechnique";
import PeacefulPlace from "./peacefulPlace/peacefulPlace";
import SelfCoaching from "./selfCoaching/selfCoaching";
import OneMinuteSuccess from "./oneMinuteSuccess/oneMinuteSuccess";
import RelaxingSounds from "./relaxingSounds/relaxingSounds";
import MiniJournal from "./miniJournal/miniJournal";
import TransitAnalysis from "./transitAnalysis/transitAnalysis";
import HumanDesign from "./humanDesign/humanDesign";
import SkyEvents from "./skyEvents";
export const componentSwitcher = {
  11: {
    name: "New Account Component",
    icon: <></>,
    component: (data) => <NewAccount data={data} />,
  },
  13: {
    name: "Human Design Component",
    icon: <></>,
    component: (data) => <HumanDesign id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  3: {
    name: "Natal Chart Component",
    icon: <></>,
    component: (data) => <NatalChart id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  4: {
    name: "Numerology Component",
    icon: <></>,
    component: (data) => <Numerology id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  5: {
    name: "Vision Board Component",
    icon: <></>,
    component: (data) => <VisionBoard id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },

  6: {
    name: "Synastry Component",
    icon: <></>,
    component: (data) => <Synastry id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },

  7: {
    name: "Affirmation Component",
    icon: <></>,
    component: (data) => <Affirmation id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  8: {
    name: "Horoscope Component",
    icon: <></>,
    component: (data) => <Horoscope id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  9: {
    name: "Memory Tree Component",
    icon: <></>,
    component: (data) => <MemoryTree id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  10: {
    name: "Memory Book Component",
    icon: <></>,
    component: (data) => <MemoryBook id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  12: {
    name: "Time Capsule Component",
    icon: <></>,
    component: (data) => <TimeCapsule id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },

  14: {
    name: "Energy Stones Component",
    icon: <></>,
    component: (data) => <EnergyStones id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },

  15: {
    name: "Affirmation Suggestion Component",
    icon: <></>,
    component: (data) => <AffirmationSuggestion data={data} />,
  },

  16: {
    name: "Meditation Component",
    icon: <></>,
    component: (data) => <Meditation data={data} />,
  },

  17: {
    name: "New Year Wishes Component",
    icon: <></>,
    component: (data) => <NewYearWishes data={data} />,
  },
  18: {
    name: "Grounding Technique Component",
    icon: <></>,
    component: (data) => <GroundingTechnique id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  19: {
    name: "Breathing Technique Component",
    icon: <></>,
    component: (data) => <BreathingTechnique id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  20: {
    name: "Body Scan Component",
    icon: <></>,
    component: (data) => <BodyScan id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  21: {
    name: "Anchoring Technique Component",
    icon: <></>,
    component: (data) => <AnchoringTechnique id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  22: {
    name: "Peaceful Place Component",
    icon: <></>,
    component: (data) => <PeacefulPlace id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  23: {
    name: "Self Coaching Component",
    icon: <></>,
    component: (data) => <SelfCoaching id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  24: {
    name: "One Minute Success Component",
    icon: <></>,
    component: (data) => <OneMinuteSuccess id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  25: {
    name: "Relaxing Sounds Component",
    icon: <></>,
    component: (data) => <RelaxingSounds id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  26: {
    name: "Mini Journal Component",
    icon: <></>,
    component: (data) => <MiniJournal id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  27: {
    name: "Transit Analysis Component",
    icon: <></>,
    component: (data) => <TransitAnalysis id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
  28: {
    name: "Sky Events Component",
    icon: <></>,
    component: (data) => <SkyEvents id={data?.id} moduleId={data?.moduleId} isOwner={data?.isOwner} />,
  },
};
